var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38461 9.59601C5.38461 9.38061 5.19614 9.19215 4.98076 9.19215H0.942298C0.726914 9.19215 0.538452 9.38061 0.538452 9.59601V12.5577C0.538452 12.7731 0.726914 12.9615 0.942298 12.9615H4.98076C5.19614 12.9615 5.38461 12.7731 5.38461 12.5577V9.59601ZM2.18089 5.42301H0.861661C0.59243 5.42301 0.457815 5.66533 0.619353 5.79995L2.7732 8.03466C2.88089 8.11543 3.04243 8.11543 3.15012 8.03466L5.30397 5.79995C5.46551 5.6384 5.33089 5.42301 5.06166 5.42301H3.79628C3.79628 4.0768 5.11551 2.73059 6.46166 2.73059V1.11514C4.03858 1.11514 2.18089 2.99983 2.18089 5.42301ZM11.2539 4.96558C11.1462 4.8848 10.9846 4.8848 10.8769 4.96558L8.72309 7.20028C8.56156 7.36183 8.69617 7.57722 8.9654 7.57722H10.2577C10.2577 9.19267 9.15386 10.2696 7.53848 10.2696V11.8851C9.96156 11.8851 11.8731 10.0004 11.8731 7.57722H13.1923C13.4616 7.57722 13.5962 7.3349 13.4346 7.20028L11.2539 4.96558ZM13.4615 0.442315C13.4615 0.226921 13.273 0.0384521 13.0576 0.0384521H9.01915C8.80376 0.0384521 8.6153 0.226921 8.6153 0.442315V3.40397C8.6153 3.61937 8.80376 3.80784 9.01915 3.80784H13.0576C13.273 3.80784 13.4615 3.61937 13.4615 3.40397V0.442315Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/Replace.8d1a07743666ea46480c528e09af6bb4.svg";
export { ForwardRef as ReactComponent };